const selectors = {
  login: '[data-login]',
  loginForm: '[data-form="login-form"]',
  recoverForm: '[data-form="recover-form"]',
  formSwitchers: '[data-set-form]',
};

class Login extends HTMLElement {
  constructor() {
    super();

    document.addEventListener('DOMContentLoaded', () => {
      this.login = this.querySelector(selectors.login);
      this.loginForm = this.login.querySelector(selectors.loginForm);
      this.recoverForm = this.login.querySelector(selectors.recoverForm);
      this.formSwitchers = [
        ...this.login.querySelectorAll(selectors.formSwitchers),
      ];
      this.loginWrapper = this.login.querySelector('[data-login-form-wrapper]');
      this.recoverWrapper = this.login.querySelector(
        '[data-recover-form-wrapper]'
      );

      this.registerEventListeners();

      this.setForm(this.login.dataset.login);
    });
  }

  setForm(formType) {
    this.login.dataset.form = formType;

    if (formType === this.loginForm.dataset.form) {
      this.loginWrapper.classList.remove('hidden');
      this.loginWrapper.classList.add('block');
      this.recoverWrapper.classList.add('hidden');
      this.recoverWrapper.classList.remove('block');
    } else if (formType === this.recoverForm.dataset.form) {
      this.loginWrapper.classList.remove('block');
      this.loginWrapper.classList.add('hidden');
      this.recoverWrapper.classList.add('block');
      this.recoverWrapper.classList.remove('hidden');
    }
  }

  registerEventListeners() {
    this.formSwitchers.forEach(switcher => {
      switcher.addEventListener('click', () => {
        const formType = switcher.dataset.setForm;

        this.setForm(formType);
      });
    });
  }
}

customElements.define('account-logins', Login);
